export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
	if (location.state && location.state.preventScroll === true) {
		return false
	}

	if (location.hash) {
		window.history.scrollRestoration = "auto"

		function scrollToHash() {
			const element = document.getElementById(location.hash.replace("#", ""))
			if (element) {
				if (element.classList.contains("chapter") == true) {
					element.scrollIntoView({ behavior: "smooth", block: "start", inline: "end" })
				} else {
					element.scrollIntoView({ behavior: "smooth", block: "center", inline: "end" })
				}
			} else {
				setTimeout(scrollToHash, 500)
			}
		}

		setTimeout(scrollToHash, 500)

		return false
	}

	window.history.scrollRestoration = "manual"

	const currentPosition = getSavedScrollPosition(location, location.key)
	const top = currentPosition ? currentPosition[1] : 0

	window.setTimeout(() => {
		window.requestAnimationFrame(() => {
			try {
				window.scrollTo({ top, behavior: "instant" })
			} catch (e) {
				window.scrollTo(top)
			}
		})
	}, 0)

	return false
}
